import { Checkbox } from 'antd'
import Control from 'components/Control/Control'
import { FormItem } from 'components/Form/FormItem'
import AntdInput from 'components/Form/Input'
import Radio from 'components/Form/RadioButton'
import AntdSelect from 'components/Form/Select'
import Label from 'components/Label/Label'
import RichEditor from 'components/RichEditor/index'
import AddIcon from 'components/icons/AddIcon'
import {
  casteList,
  religionList,
} from 'modules/Onboarding/Register/AdditionalDetails/Constant'
import {
  Heading,
  RadioGroup,
  Text,
} from 'modules/Onboarding/Register/AdditionalDetails/style'
import { AdjustIcon } from 'modules/Onboarding/Register/Education/style'
import React, { Fragment, useState } from 'react'

const AdditionalInfoForm = ({
  form,
  formRef,
  hobbies,
  languages,
  locations,
  setLocations,
  socials,
  hobbiesHandler,
  languagesHandler,
  socialsHandler,
  casteValue,
  setCasteValue,
  religionValue,
  setReligionValue,
  objective,
  setObjective,
  extraCurriculars,
  setExtraCurriculars,
  hobbieList,
  languageList,
  socialMediaList,
  socialURLList,
  getHobbbieList,
  getLanguageList,
  getSocailMediaList,
  isPhysicallyChallenged,
  isAnyWhere,
  setIsAnyWhere,
  setIsPhysicallyChallenged,
  studentFormData,
  getPerfCityData,
  allLocations,
}) => {
  const [perfCityList, setPerfCityList] = useState([])

  const RadioOptions = [
    {
      id: 1,
      label: 'Yes',
      value: true,
    },
    {
      id: 2,
      label: 'No',
      value: false,
    },
  ]

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const onChangeCaste = value => {
    setCasteValue(value)
    form.setFieldsValue({
      caste: value,
    })
  }
  const onChangeReligion = value => {
    setReligionValue(value)
    form.setFieldsValue({
      religion: value,
    })
  }

  const locationHandler = (selectedValues, selectedOptions) => {
    const selectedPayloads = selectedOptions?.map(item => item.option)

    form.setFieldsValue({
      preferredJobLocation: selectedPayloads,
    })
    setLocations(selectedPayloads)
  }

  const isAnyWhereOnChange = data => {
    setIsAnyWhere(data?.target?.checked)
    form.setFieldsValue({
      isAnyWhere: data?.target?.checked,
    })
  }

  const physicallyOnchange = data => {
    if (data === false) {
      form.setFieldsValue({ physicalChallenge: '' })
    }
    setIsPhysicallyChallenged(data)
  }

  const onChangeCareerObject = value => {
    form.setFieldsValue({
      objective: value,
    })
    setObjective(value)
  }

  const onChangeExtraCurriculars = value => {
    form.setFieldsValue({
      extraCurriculars: value,
    })
    setExtraCurriculars(value)
  }

  const countRichTextCharacters = richText => {
    // Handle null/undefined values
    if (!richText) return 0
    
    // Convert to string if it's not already
    const textString = typeof richText === 'string' ? richText : String(richText)
    
    // Remove HTML tags using a regular expression
    const plainText = textString.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ')

    // Count the characters in the plain text
    const characterCount = plainText.length || 0

    return characterCount
  }

  return (
    <Fragment>
      <Control spaceBetween gap="15px" width={'100%'}>
        <Control column width={'50%'}>
          <Label>Caste</Label>
          <AntdSelect
            OptionData={casteList}
            name={'caste'}
            onChange={onChangeCaste}
            valueParam="name"
            nameParam="name"
            value={casteValue}
            placeholder="Eg. General"
            dropdownMatchSelectWidth={true}
          />
        </Control>
        <Control column width={'50%'}>
          <Label>Religion</Label>
          <AntdSelect
            OptionData={religionList}
            name={'religion'}
            onChange={onChangeReligion}
            valueParam="name"
            nameParam="name"
            value={religionValue}
            placeholder="Eg. Hindu"
            dropdownMatchSelectWidth={true}
          />
        </Control>
      </Control>
      <Control column top="20px">
        <Label>Are You Physically Challenged:</Label>

        <RadioGroup
          onChange={({ target }) => physicallyOnchange(target.value)}
          defaultValue={isPhysicallyChallenged}
        >
          {RadioOptions?.map((item, index) => (
            <Radio
              key={index + 'options'}
              border={true}
              label={item?.label}
              value={item?.value}
            />
          ))}
        </RadioGroup>
        {isPhysicallyChallenged && (
          <Control top="20px">
            <AntdInput
              placeholder="Physical Challenge"
              name={'physicalChallenge'}
            />
          </Control>
        )}
      </Control>

      <Control top="40px">
        <Heading>Hobbies</Heading>
      </Control>
      <Control column top="10px">
        <Label>What do you like?</Label>
        {!!hobbies &&
          hobbies.map((obj, index) => {
            return (
              <obj.component
                key={obj}
                type={obj?.type}
                onRemove={() => hobbiesHandler(false, true, obj?.type)}
                hobbieList={hobbieList}
                getHobbbieList={getHobbbieList}
              />
            )
          })}
      </Control>
      <Control
        onClick={() => hobbiesHandler(true, false)}
        style={{ cursor: 'pointer' }}
        gap="10px"
        alignCenter
        width={'30%'}
      >
        <AdjustIcon>
          <AddIcon />
        </AdjustIcon>
        <Text>Add Hobbies</Text>
      </Control>

      <Control top="40px">
        <Heading>Languages</Heading>
      </Control>
      <Control column top="10px">
        {!!languages &&
          languages?.map((obj, index) => {
            return (
              <obj.component
                key={obj}
                type={obj?.type}
                onRemove={() => languagesHandler(false, true, obj?.type)}
                languageList={languageList}
                getLanguageList={getLanguageList}
              />
            )
          })}
      </Control>
      <Control
        onClick={() => languagesHandler(true, false)}
        style={{ cursor: 'pointer' }}
        gap="10px"
        alignCenter
        width={'30%'}
      >
        <AdjustIcon>
          <AddIcon />
        </AdjustIcon>
        <Text>Add Languages</Text>
      </Control>
      <FormItem name={'isAnyWhere'} />
      <Control>
        <Heading>Preferred Job Locations</Heading>
      </Control>
      <Control column top="10px">
        <Label>Where do you want to work *</Label>
        <Control column bottom="10px">
          <Checkbox onChange={isAnyWhereOnChange} checked={isAnyWhere}>
            {'Anywhere'}
          </Checkbox>
        </Control>

        {!isAnyWhere && (
          <>
            <FormItem style={{ height: '10px' }} name={'preferredJobLocation'}>
              <div></div>
            </FormItem>

            <AntdSelect
              placeholder="Eg.Chennai"
              name={'preferredJobLocation'}
              rules={[
                {
                  validator: async (_, value) => {
                    if (
                      !locations?.length &&
                      (!Array.isArray(value) || value?.length === 0)
                    ) {
                      return Promise.reject(
                        new Error('Please enter preferred job location!')
                      )
                    }
                    return Promise.resolve()
                  },
                },
              ]}
              OptionData={allLocations}
              filterOption={false}
              onChange={locationHandler}
              value={locations}
              mode="multiple"
              maxTagCount={3}
              valueParam="value"
              nameParam="label"
              showSearch={true}
              iskey={true}
              onSearch={data => getPerfCityData(data)}
              onDropdownVisibleChange={open => {
                if (!open) {
                  getPerfCityData('')
                  form.setFieldsValue({
                    preferredJobLocation: locations,
                  })
                }
              }}
            />
          </>
        )}
      </Control>

      <Control top="40px">
        <Heading>Social Media</Heading>
      </Control>
      <Control column top="10px">
        {!!socials &&
          socials.map(obj => {
            return (
              <obj.component
                key={obj}
                type={obj?.type}
                socialMediaList={socialMediaList}
                socialURLList={socialURLList}
                getSocailMediaList={getSocailMediaList}
                onRemove={() => socialsHandler(false, true, obj?.type)}
              />
            )
          })}
      </Control>
      <Control
        onClick={() => socialsHandler(true, false)}
        style={{ cursor: 'pointer' }}
        gap="10px"
        alignCenter
        width={'30%'}
      >
        <AdjustIcon>
          <AddIcon />
        </AdjustIcon>
        <Text>Add more links</Text>
      </Control>

      <Control top="40px">
        <Heading>Career Objective</Heading>
      </Control>
      <Control>
        <FormItem
          name={'objective'}
          rules={[
            {
              validator: async (_, value) => {
                if (countRichTextCharacters(objective) > 1000) {
                  return Promise.reject(
                    new Error('Maximum 1000 Character allowed!')
                  )
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <RichEditor value={objective} onChange={onChangeCareerObject} />
          {'Characters: ' + countRichTextCharacters(objective) + ' / 1000'}
        </FormItem>
      </Control>

      <Control top="40px">
        <Heading>Extracurricular Activities</Heading>
      </Control>
      <Control>
        <FormItem
          name={'extraCurriculars'}
          rules={[
            {
              validator: async (_, value) => {
                if (countRichTextCharacters(extraCurriculars) > 1000) {
                  return Promise.reject(
                    new Error('Maximum 1000 Character allowed!')
                  )
                }
                return Promise.resolve()
              },
            },
          ]}
        >
          <RichEditor
            value={extraCurriculars}
            onChange={onChangeExtraCurriculars}
          />
          {'Characters: ' +
            countRichTextCharacters(extraCurriculars) +
            ' / 1000'}
        </FormItem>
      </Control>
    </Fragment>
  )
}

export default AdditionalInfoForm
